<template>
  <DxLookup
    :ref="dropDownBoxRefName"
    :drop-down-options="dropDownOptions"
    :data-source="dataSource"
    :value.sync="currentValue"
    display-expr="Code"
    value-expr="Code"
    :serach-expr="['Code', 'Description']"
    search-mode="contains"
    :on-value-changed="onSelectionChanged"
    item-template="itemBranch"
    field-template="branchTemplate"
    @focus-in="focusIn"
    :disabled="disabled"
  >
    <template #branchTemplate="{ data }">
      <div class="gc-auto-cmp">{{ data.Description }}</div>
    </template>
    <template #itemBranch="{ data }">
      <div class="custom-auto-complete">
        <span class="auto-complete-primary">{{ data.Description }}</span>
        <span class="auto-complete-secondary">{{ data.Code }}</span>
      </div>
    </template>
  </DxLookup>
</template>
<script>
import { DxLookup } from "devextreme-vue/lookup";

const dropDownBoxRefName = "dropDownBoxRef";

export default {
  components: {
    DxLookup,
  },
  props: {
    value: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    onValueChanged: {
      type: Function,
      default: () => function() {},
    },
    dataSource: {
      type: Object,
      default: () => {},
    },
    cellInfo: {
      type: Object,
      default: () => {},
    },
    focusIn: {
      type: Function,
      default: () => function() {},
    },
  },
  data() {
    return {
      currentValue: this.value,
      dropDownOptions: { width: 500 },
      dropDownBoxRefName,
    };
  },
  methods: {
    onSelectionChanged(selectionChangedArgs) {
      this.currentValue = selectionChangedArgs.value;
      this.onValueChanged(selectionChangedArgs, this.cellInfo);
    },
  },
};
</script>

<style lang="scss" scoped>
.gc-dropdown-list-item {
  font-size: 14px;
}
</style>
